import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarningIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1000 1000",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M472 605H528L544 403V195H456V403ZM499 801Q534 801 547 787Q560 773 560 749V737Q560 714 547 699.5Q534 685 499 685Q465 685 452.5 699.5Q440 714 440 737V749Q440 773 452.5 787Q465 801 499 801ZM0 498C0 830 190 1000 500 1000C810 1000 1000 830 1000 498C1000 191 810 0 500 0C190 0 0 191 0 498ZM82 558V438C82 235 260 74 500 74C740 74 918 235 918 438V558C918 771 768 926 504 926C240 926 82 771 82 558Z" })
});
export default SvgWarningIcon;
